import React, { FC } from 'react'
import { useStaticQuery } from "gatsby"
import { graphql } from "gatsby"
import { OtherSuccessStories } from './OtherSuccessStories';
import { ArticleNode,  SuccessStoryQueryData } from '../../utils/core';
import { useI18next } from '../../plugins/i18next/useI18next';

const SuccessStorySideBar: FC<{currentSlug: string}> = ({ currentSlug }) => {
  const data: SuccessStoryQueryData = useStaticQuery(IndexQuery);
  const { i18n } = useI18next();
  const language = i18n.language;

  const edges = data?.allMarkdownRemark?.edges;

  const successstories: ArticleNode[] = edges.map((post): ArticleNode => {
    const { id, html, frontmatter, fields  } = post.node;
    return {
      id,
      html,
      frontmatter,
      fields
    };
  });

  const filteredItems = successstories.filter((p) =>  p.frontmatter.language === language)

  return (
    <div className="successstory-other-container">
       <OtherSuccessStories successStories={filteredItems} currentSlug={currentSlug} />
    </div>
  );
};

export const IndexQuery = graphql`
  query SuccessStory($language: String) {
  allMarkdownRemark(
   filter: {frontmatter: {category: {eq: "SuccessStory"}}}
     sort: {frontmatter: {date: DESC}}
    ) {
    edges {
      node {
        frontmatter {
          slug
          title
          date
          category
          sector
          description
          language
          blogimage {
              childImageSharp {
                gatsbyImageData
              }
          }
          successstoryfile {
            publicURL
          }
          videoId
          videoTitle
      }
      fields {
        language
      }
    }
  }
  }
  locales: allLocale(filter: {language: {eq: $language}, ns: {in: ["components","pages"]}}) {
    edges {
      node {
        ns
        language
        data
      }
    }
  }
  }
`;


export default SuccessStorySideBar